








import { defineComponent } from '@vue/composition-api';
import cIconPlusButton     from '@/components/icons/icon-plus-button.component.vue';

export default defineComponent({
  name: 'cPlusButton',
  components: {
    cIconPlusButton,
  },
  props: {
    buttonText: {
      type: String,
      default: '',
    },
  },
});
